import httpApi from '../api/httpApi';
import useSWR from 'swr';
import { AddressResp } from '../../models/Addresses';

const URL = '/api/v1/admin/addresses';

const useAdminUserAddressesSWR = (userId) => {
    const fetch = (query): Promise<AddressResp[]> => {
        return httpApi
            .get<{ companyAddresses: AddressResp[] }>(query)
            .then((res) => {
                return res.getData().companyAddresses;
            })
            .catch((error) => {
                throw error;
            });
    };

    const { data, error, isLoading, mutate } = useSWR(
        URL + '/' + userId,
        fetch,
        {
            dedupingInterval: 600000, // 10min
            errorRetryCount: 3,
        }
    );

    return {
        addresses: data ? data : null,
        isLoading: isLoading,
        isError: error,
        forceRefresh: mutate,
    };
};

export default useAdminUserAddressesSWR;
